import { i18n } from '@booking-portal/config/i18n-config';
import type { App } from 'vue';

export function setupI18n(app: App) {
  app.use(i18n);
}
